import { useState } from "react";
import Form from "react-bootstrap/Form";
import translateText, { currentLanguage } from "../signals/language.signal";
import { logToken } from "../signals/login.signal";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Collapse, IconButton } from "@mui/material";

const NOTESFORM = () => {
  const [notes, setnotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessageType, setAlertMessageType] = useState("error");

  // const [validated, setValidated] = useState(false);
  const showAlertMessage = (MSG, type) => {
    setAlertMessage(MSG);
    setAlertMessageType(type);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  const handleNotesChange = (event) => {
    setnotes(event.target.value);
  };

  const handleNoteSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        setLoading(true);
        const bearerToken = logToken.value;
        const response = await fetch(
          "https://alguthmi.co/API/B2BAppAPI/insertNotes.php",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              origin: "http://alguthmi.co",
            },
            body: JSON.stringify({
              NOTE: notes,
            }),
          }
        );
        if (response.ok) {
          form.reset();
          setnotes("");
          showAlertMessage("Note Send", "success");
        } else {
          showAlertMessage("Authentication failed", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        showAlertMessage("Error submitting form. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Collapse
        in={open}
        className="position-fixed m-2"
        style={{ zIndex: 1000, direction: "ltr", top: 0 }}
      >
        <Alert
          severity={alertMessageType}
          variant="filled"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              className="m-0"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" className="m-0" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alertMessage}
        </Alert>
      </Collapse>
      <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
        <div className="loginContaner bg-white p-3 p-md-5 w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
          <Form onSubmit={handleNoteSubmit} className="w-100">
            <div className="mb-3">
              <label htmlFor="clientCode" className="form-label">
                {translateText(currentLanguage.value, "Notes")}
              </label>
              <textarea
                style={{ height: "100px" }}
                className="form-control"
                placeholder={
                  translateText(currentLanguage.value, "Notes") + "..."
                }
                id="floatingTextarea"
                value={notes}
                onChange={handleNotesChange}
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="btn btn-primary border pe-3 ps-3 w-100"
              style={{ background: primary.value, color: primaryFount.value }}
              disabled={loading}
            >
              {loading
                ? translateText(currentLanguage.value, "Loading") + "..."
                : translateText(currentLanguage.value, "Send")}
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default NOTESFORM;
